module.exports = __webpack_public_path__ + "static/media/radio.11c9a4e2.svg";